"use strict";

var _defineProperty = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/defineProperty.js");

var _slicedToArray = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _regeneratorRuntime = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/opt/build/repo/apps/multi-step-app/node_modules/.pnpm/@babel+runtime@7.16.5/node_modules/@babel/runtime/helpers/createClass.js");

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Lead = void 0;

var cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));

var FetchActions_1 = require("./FetchActions");

var utils_1 = require("../common/utils");

var Lead = /*#__PURE__*/function () {
  function Lead(client) {
    var _this = this;

    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        campaign = _ref.campaign,
        _ref$initialState = _ref.initialState,
        initialState = _ref$initialState === void 0 ? {} : _ref$initialState,
        _ref$requiredPartialF = _ref.requiredPartialFields,
        requiredPartialFields = _ref$requiredPartialF === void 0 ? [] : _ref$requiredPartialF,
        _ref$test = _ref.test,
        test = _ref$test === void 0 ? false : _ref$test,
        events = _ref.events;

    _classCallCheck(this, Lead);

    this._meta = {
      leadId: "",
      postedDt: null,
      testLead: false,
      approved: false
    };
    this.requiredPartialFields = [];
    this.actionQueue = new Set();
    this.results = [];
    this.resultIndex = 0;
    this.processor = Promise.resolve([]);
    /**
     * Get the value of a given lead field.
     */

    this.get = function (key) {
      return _this._state[key];
    };
    /**
     * Set the value of a given lead field.
     */


    this.set = function (key, value) {
      _this._state[key] = _this.events.onFieldUpdate(key, value);

      _this.events.onUpdate(_this._state);

      return _this.fields;
    };
    /**
     * Process a single payload.
     */


    this.processPayload = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action) {
        var _a, _b, payload, response, isNewLead;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                /* merge campaign data & lpTest field into payload */
                payload = Object.assign(action.payload, {
                  lpCampaignID: (_a = _this.campaign) === null || _a === void 0 ? void 0 : _a.postId,
                  lpCampaignKey: (_b = _this.campaign) === null || _b === void 0 ? void 0 : _b.postKey
                }, {
                  lpTest: _this._meta.testLead ? "1" : "0",
                  lpResponse: "JSON"
                });
                _context.prev = 1;

                if (!_this._meta.leadId) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return _this.actions.update(payload, action.updateOptions);

              case 5:
                _context.t0 = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.next = 10;
                return _this.actions.post(payload);

              case 10:
                _context.t0 = _context.sent;

              case 11:
                response = _context.t0;
                isNewLead = response && response.leadId && !_this._meta.leadId;

                if (isNewLead) {
                  _this._meta.leadId = response.leadId;
                  _this._meta.postedDt = new Date();
                }

                _this.results.push({
                  type: "success",
                  data: response
                });

                return _context.abrupt("return", true);

              case 18:
                _context.prev = 18;
                _context.t1 = _context["catch"](1);

                /* process caught error and add to this.results */
                if (_context.t1 instanceof Error) {
                  _this.results.push({
                    type: "error",
                    data: {
                      message: _context.t1.message,
                      stack: _context.t1.stack,
                      originalError: _context.t1
                    }
                  });
                } else {
                  typeof _context.t1 === "object" ? _this.results.push({
                    type: "error",
                    data: {
                      message: _context.t1.message || _context.t1.value || "Unknown Error",
                      originalError: _context.t1
                    }
                  }) : _this.results.push({
                    type: "error",
                    data: {
                      message: String(_context.t1),
                      originalError: _context.t1
                    }
                  });
                }

                return _context.abrupt("return", false);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 18]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }();
    /**
     * Process a snapshot of the action queue.
     */


    this.processQueue = function () {
      var queue = Array.from(_this.actionQueue);
      queue.forEach(function (action) {
        _this.actionQueue.delete(action);
      });
      _this.processor = _this.processor.then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iterator, _step, action;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iterator = _createForOfIteratorHelper(queue);
                _context2.prev = 1;

                _iterator.s();

              case 3:
                if ((_step = _iterator.n()).done) {
                  _context2.next = 9;
                  break;
                }

                action = _step.value;
                _context2.next = 7;
                return _this.processPayload(action);

              case 7:
                _context2.next = 3;
                break;

              case 9:
                _context2.next = 14;
                break;

              case 11:
                _context2.prev = 11;
                _context2.t0 = _context2["catch"](1);

                _iterator.e(_context2.t0);

              case 14:
                _context2.prev = 14;

                _iterator.f();

                return _context2.finish(14);

              case 17:
                return _context2.abrupt("return", []);

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[1, 11, 14, 17]]);
      })));
    };
    /**
     * Returns a promise that can be awaited, signalling the end of all queued actions.
     *
     * @param {boolean} all - Should the entire results collection be returned?
     * default: `false`
     *
     * If `false`, only the latest result will be returned.
     */


    this.promise = function () {
      var all = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      return _this.processor = _this.processor.then(function () {
        var resultIndex = _this.resultIndex;
        _this.resultIndex = _this.results.length - 1;

        var results = _this.results.slice(resultIndex);

        if (!all) {
          return results.pop();
        }

        return results;
      });
    };

    this.addAction = function (updateOptions) {
      var payload = (0, cloneDeep_1.default)(_this._state);

      _this.actionQueue.add({
        payload: payload,
        updateOptions: updateOptions
      });

      _this.processQueue();

      return _this;
    };
    /**
     * Sends lead to leadspedia
     */


    this.post = function () {
      return _this.addAction();
    };
    /**
     * Merges the input state with the existing lead state
     */


    this.merge = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      Object.assign(_this._state, _this.events.onMerge(state, _this._state));

      _this.events.onUpdate(_this._state);
    };
    /**
     * Updates an existing lead in Leadspedia and optionally redistributes the
     * lead to a contract if the `redistribute` option is set.
     *
     * Redistributing a lead should only be for an existing lead.
     */


    this.update = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var updateOptions = arguments.length > 1 ? arguments[1] : undefined;

      _this.merge(state);

      if (_this._meta.leadId) {
        return _this.addAction(updateOptions);
      }

      return _this;
    };
    /**
     * Attempts to post a partial lead to leadspedia.
     */


    this.attemptPost = function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _a, _b;

      _this.merge(state);
      /* check for required fields */


      var hasAllRequiredFields = (_b = (_a = _this.requiredPartialFields) === null || _a === void 0 ? void 0 : _a.every(function (field) {
        return _this._state.hasOwnProperty(field);
      })) !== null && _b !== void 0 ? _b : false;

      if (_this._meta.approved && hasAllRequiredFields) {
        return _this.addAction();
      }

      return _this;
    };
    /**
     * Flags a lead as approved and attempts to post a partial lead
     * if all required fields are present.
     */


    this.approveAndAttemptPost = function () {
      _this._meta.approved = true;
      return _this.attemptPost();
    };
    /**
     * Native toJSON method
     */


    this.toJSON = function () {
      return {
        __type: utils_1.LEAD_CACHE_IDENTIFIER,
        state: _this.state,
        meta: _this.meta
      };
    };

    this.requiredPartialFields = requiredPartialFields;
    this.campaign = campaign;
    this.events = events;

    if ((0, utils_1.isCachedState)(initialState)) {
      this._state = initialState.state;
      Object.assign(this._meta, initialState.meta);
    } else {
      this._state = initialState;
      this._meta.testLead = test;
    }

    this.actions = Object.entries({
      baseActions: FetchActions_1.baseActions,
      leadIdActions: FetchActions_1.leadIdActions
    }).reduce(function (acc, _ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
          actionType = _ref5[0],
          methods = _ref5[1];

      methods.forEach(function (method) {
        switch (actionType) {
          case "baseActions":
            {
              Object.assign(acc, _defineProperty({}, method, client[method]));
              break;
            }

          case "leadIdActions":
            {
              Object.assign(acc, _defineProperty({}, method, function () {
                var fn = client[method];

                if (!fn || typeof fn !== "function") {
                  throw new Error("Action method \"".concat(method, "\" is malformed!"));
                }

                if (_this._meta.leadId) {
                  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                  }

                  fn.apply(void 0, [_this._meta.leadId].concat(args));
                } else {
                  throw new Error("You cannot perform action \"".concat(method, "\" with a lead that hasn't been posted"));
                }
              }));
              break;
            }
        }
      });
      return acc;
    }, {});
  }

  _createClass(Lead, [{
    key: "fields",
    get: function get() {
      return {
        get: this.get,
        set: this.set
      };
    }
    /**
     * Returns a copy of the current lead state
     */

  }, {
    key: "state",
    get: function get() {
      return (0, cloneDeep_1.default)(this._state);
    }
    /**
     * Returns an array containing all of the results from each
     * call to leadspedia
     */

  }, {
    key: "allResults",
    get: function get() {
      return (0, cloneDeep_1.default)(this.results);
    }
    /**
     * Collection of metadata representing various status values
     * of the current lead instance
     */

  }, {
    key: "meta",
    get: function get() {
      return (0, cloneDeep_1.default)(this._meta);
    }
  }]);

  return Lead;
}();

exports.Lead = Lead;